export enum CorporatePartCostStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  OLD = 'old',
  PENDING = 'pending',
}
